import React, { type ComponentType } from 'react';
// eslint-disable-next-line @atlaskit/design-system/no-unsupported-drag-and-drop-libraries
import type { DraggableStateSnapshot } from 'react-beautiful-dnd';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { useIntl } from '@atlassian/jira-intl';
import {
	type DO_NOT_ANIMATE_WIDTH,
	FIELD_TYPE_LIST,
} from '@atlassian/jira-project-settings-apps-issue-type-page-product-features/src/common/constants.tsx';
import type { FieldTypeObj } from '@atlassian/jira-project-settings-apps-issue-type-page-product-features/src/common/types/layout-items.tsx';
import { ExpandableSection } from '@atlassian/jira-project-settings-apps-issue-type-page-product-features/src/common/ui/sidebar/expandable-section/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import messages from './messages.tsx';

type Props = {
	isMouseDragging: boolean;
	isFieldsLimitReached: boolean;
	fieldLimitPerProject: number | null;
	issueTypeName: string;
	availableFieldTypes: FieldTypeObj[];
	getDropAnimationWidth: (arg1: DraggableStateSnapshot) => number | typeof DO_NOT_ANIMATE_WIDTH;
	FieldTypeList: ComponentType<{
		id: string;
		isDisabled: boolean;
		messageTooltipWhenDisabled: string;
		items: FieldTypeObj[];
		areItemsClickable: boolean;
		onFieldTypeClicked: (fieldType: FieldTypeObj) => void;
		getDropAnimationWidth: (arg1: DraggableStateSnapshot) => number | typeof DO_NOT_ANIMATE_WIDTH;
	}>;
	onFieldTypeClicked: (fieldType: FieldTypeObj) => void;
};

export const FieldTypes = ({
	FieldTypeList,
	isFieldsLimitReached,
	availableFieldTypes,
	fieldLimitPerProject,
	isMouseDragging,
	onFieldTypeClicked,
	getDropAnimationWidth,
}: Props) => {
	const { formatMessage } = useIntl();

	return (
		<ExpandableSection
			initialOpen={
				!expValEquals('tmp_issue_type_edit_changes_reducing_duplicate_cfs', 'cohort', 'experiment')
			}
			variant={
				expValEquals('tmp_issue_type_edit_changes_reducing_duplicate_cfs', 'cohort', 'experiment')
					? 'regular'
					: 'large'
			}
			label={formatMessage(messages.title)}
			description={
				fg('itsm-issue-renaming')
					? formatMessage(messages.descriptionIssueTermRefresh)
					: formatMessage(messages.description)
			}
		>
			<FieldTypeList
				isDisabled={isFieldsLimitReached}
				messageTooltipWhenDisabled={formatMessage(messages.fieldCreationLimitReached, {
					fieldLimit: fieldLimitPerProject,
				})}
				id={FIELD_TYPE_LIST}
				items={availableFieldTypes}
				areItemsClickable={!isMouseDragging}
				onFieldTypeClicked={onFieldTypeClicked}
				getDropAnimationWidth={getDropAnimationWidth}
			/>
		</ExpandableSection>
	);
};
